import React from "react";
import { useParams } from "react-router-dom";
import resourcesData from "./Resources.json";

const BlogDetails = () => {
  const { title } = useParams();

  const blog = resourcesData.Blogs.find(
    (item) => item.slug === title
  );

  if (!blog) {
    return <div className="blog-not-found">Blog Not Found</div>;
  }

  const sections = Object.keys(blog.content)
    .filter((key) => key.startsWith("section"))
    .sort((a, b) => Number(a.replace("section", "")) - Number(b.replace("section", "")))
    .map((key) => blog.content[key]);

  return (
    <div className="backdiv">
      <section className="detail-hero">
        <span className="case-tag">{blog.content.date}</span>

        <h2 className="detail-head">
          {blog.content.heading}
        </h2>

        <p className="case-tag mt-5">
          By <strong>{blog.content.author}</strong>
        </p>
      </section>

      <div className="detail-container">

        {/* Intro */}
        <div className="case-block1">
          <p className="main-text">
            <p dangerouslySetInnerHTML={{__html: blog.content.intro}} />
          </p>

          <div className="details-img">
            <img
              src={blog.img}
              alt={blog.content.heading}
              className="cover-img"
              loading="lazy"
            />
          </div>
        </div>

        {sections.map((section, index) => (
          <div className="blog-section" key={index}>
            <h2 className="detail-title">{section.title}</h2>

            {section.content && (
              <p className="main-text">
               <p dangerouslySetInnerHTML={{__html: section.content}} />
               </p>
            )}

            {/* Bullet Points */}
            {section.points && (
              <ul className="blog-points">
                {section.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            )}

            {/* Sub Sections */}
            {section.subSections &&
              section.subSections.map((sub, i) => (
                <div className="blog-subsection" key={i}>
                  <h3 className="sub-title">
                    {sub.title}
                  </h3>

                  <p className="main-text">
                    {sub.content}
                  </p>

                  {sub.points && (
                    <ul className="blog-points">
                      {sub.points.map((point, j) => (
                        <li key={j}>{point}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
          </div>
        ))}

   
        <div className="blog-conclusion">
          <h2 className="detail-title">
            Conclusion
          </h2>

          <p className="main-text">
             <p dangerouslySetInnerHTML={{__html: blog.content.conclusion}} />
          </p>
        </div>

      </div>
    </div>
  );
};

export default BlogDetails;